import {
  ACTION_LOAD_DESIGNS,
  ACTION_LOAD_FILTERS,
  ACTION_LIST_PRODUCTS,
  ACTION_SEARCH_DESIGNS,
  ACTION_AWAIT_REQUEST
} from './action-types';
import {
  MUTATION_ADD_DESIGNS,
  MUTATION_CLEAR_SEARCH,
  MUTATION_SET_PRODUCTS,
  MUTATION_SET_FILTERS,
  MUTATION_SEARCH_DESIGNS
} from './mutation-types';
import http from './helpers/http-common';
import { DEFAULT_MOTIFS } from '../../utils/configure-environment';
import { CREATOR_API } from '@/api/creator-api';
import { useLoadingIndicatorStore } from '../store-pinia/loading-indicator';

const buildQueryString = params =>
  Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');

export default {
  // eslint-disable-next-line no-empty-pattern
  async [ACTION_AWAIT_REQUEST]({}, actionToAwait) {
    await useLoadingIndicatorStore().awaitRequest(actionToAwait);
  },
  async [ACTION_LOAD_DESIGNS]({ commit }, [start, limit, locale]) {
    const { data } = await http.get(
      `/design?start=${start}&limit=${limit}&locale=${locale}`
    );
    commit(MUTATION_ADD_DESIGNS, [data, start]);
  },
  async [ACTION_SEARCH_DESIGNS]({ commit }, [start, limit, query, locale]) {
    if (start === 0) {
      commit(MUTATION_CLEAR_SEARCH);
    }

    const params = { start, limit, query, locale };
    if (query === '') {
      params.ids = DEFAULT_MOTIFS;
    }

    const { data } = await http.get(`/design?${buildQueryString(params)}`);
    commit(MUTATION_ADD_DESIGNS, [data, start]);
    commit(MUTATION_SEARCH_DESIGNS, query);
  },
  async [ACTION_LIST_PRODUCTS]({ commit, state }) {
    commit(MUTATION_SET_PRODUCTS, []);

    const params = {};
    Object.entries(state.filters).forEach(([category, categoryData]) => {
      if (categoryData) {
        Object.entries(categoryData.filters).forEach(([filter, filterData]) => {
          if (filterData.selected) {
            params[category] = params[category] || [];
            params[category].push(filter);
          }
        });
      }
    });

    const { data } = await CREATOR_API.products.get();
    commit(MUTATION_SET_PRODUCTS, data);
  },
  async [ACTION_LOAD_FILTERS]({ commit }) {
    const { data } = await CREATOR_API.productFilters.get();
    commit(MUTATION_SET_FILTERS, data.filters);
  }
};
